import { ChatChannel, ChatChannelInterface } from "./ChatChannel";

interface ChatChannelUserInterface extends ChatChannelInterface {
    merchant: boolean;
}

export class ChatChannelUser extends ChatChannel implements ChatChannelUserInterface {
    merchant: boolean;

    constructor(data: ChatChannelUserInterface) {
        super(data);
        this.merchant = data.merchant;
    }
}